import { customAxios, FDV_URL } from '../constants';

export default function(
  codSolicitud, fichaVenta, canVehiculos, codTipoAutExcepcional,
  codUsuarioRegul, fecEstimadaRegul, obsSolicitud, pedidos
) {
  const data = {
    canVehiculos,
    codSolicitud:codSolicitud,
    codAreaVta: fichaVenta.codAreaVta,
    codCliente: fichaVenta.codClie?fichaVenta.codClie:fichaVenta.codCliente,
    codFamiliaVeh: fichaVenta.codFamiliaVeh,
    codFilial: fichaVenta.codFilial,
    codMarca: fichaVenta.codMarca,
    codTipoAutExcepcional,
    codUsuarioRegul,
    fecEstimadaRegul: fecEstimadaRegul?fecEstimadaRegul.format('DD/MM/YYYY'):'',
    numFichaVtaVeh: fichaVenta.numFichaVtaVeh,
    obsSolicitud,
    numPedidoVeh:pedidos
  };

  if(codSolicitud===0) {
    return customAxios.post(`${FDV_URL}/autorizacion-excepcional/solicitudes`, data);
  } else {
    return customAxios.put(`${FDV_URL}/autorizacion-excepcional/solicitudes/${codSolicitud}`, data);
  }
}



// WEBPACK FOOTER //
// ./src/utils/addSolicitudExcep.js